
// Import supabase configuration
import supabase from '../config/supabase'


const getUser = (email, password) => {
  //supabase functions calls
  return supabase.auth.signIn({
    email: email,
    password: password,
  });
};

const addNewUser = (email, password) => {
  //supabase functions calls
  return supabase.auth.signUp({
    email: email,
    password: password,
  });
};

const fetchSharedEmails = (boardId) => {
  //supabase functions calls
  return supabase
  .from("board_clients_invitation")
  .select("email,expireDate,link_shared_at,url_with_token,masked_url")
  .eq("board", boardId);
};

const nameSearch = (text) => {
  return supabase
  .from('all_profiles')
  .select('*')
  .ilike('full_name', `%${text}%`)
}

const emailSearch = (text) => {
  return supabase
  .from('all_profiles')
  .select('*')
  .textSearch('email', `${text}:*`)
}

const primarySkillsSearch = (text) => {
  return supabase
  .rpc('skills_search', { text_input: `${text}` })
}

const indexSearch = (text) => {
  return supabase
  .rpc('index_search', { text_input: `${text}` })
}

const secondarySkillsSearch = (text) => {
  return supabase
  .rpc('secondaryskills_search', { text_input: `${text}` })
}

const locationSearch = (text) => {
  return supabase
  .from('all_profiles')
  .select('*')
  .ilike('location', `%${text}%`)
}

const gaperIdSearch = (text) => {
  return supabase
  .from('all_profiles')
  .select('*')
  .eq('serial_no', `${text}`)
}

const topFiveProfiles = () => {
  return supabase
  .from('all_profiles')
  .select('*')
  .limit(5)
}

const createBoard = (data) => {
  return supabase
  .from('board')
  .insert(data)
}

const updateBoard = (data) => {
  return supabase
  .from('board')
  .update(data)
  .eq('id', data.id)
}

const deleteBoard = (id) => {
  return supabase
  .from('board')
  .delete()
  .eq('id', id)
}

const getAllBoards = () => {
  return supabase
  .from('board')
  .select("*,board_profiles(*)")
}

const getClientAllBoards = (dashboardId) => {
  return supabase
  .from('board_clients_invitation')
  .select("*,board(*)")
  .match({dashboard_id : dashboardId})
}

const getClientNotification = (client_invitation_id) => {
  return supabase
  .from('notifications')
  .select("*")
  .order('created_at', { ascending: false })
  .match({client: client_invitation_id});
}

const getClient = (boardId, url_with_token) => {
  return supabase
  .from("board_clients_invitation")
  .select("*,board(*)")
  .match({ board: boardId, url_with_token: url_with_token });
}

const getPublicClient = (boardId) => {
  return supabase
  .from("board_profiles")
  .select("*,board(*)")
  .match({ board: boardId });

}

const getClientProfilesDetails = (allIds) => {
  return supabase
  .from("all_profiles")
  .select("*")
  .in('id', allIds);
}

const updateClientProfiles = (profiles, clientId) => {
  return supabase
  .from("board_clients_invitation")
  .update({profiles: profiles})
  .match({ id: clientId });
}

const service = {
  getUser,
  addNewUser,
  nameSearch,
  emailSearch,
  primarySkillsSearch,
  secondarySkillsSearch,
  locationSearch,
  gaperIdSearch,
  topFiveProfiles,
  createBoard,
  updateBoard,
  getAllBoards,
  deleteBoard,
  indexSearch,
  fetchSharedEmails,
  getClientNotification,
  updateClientProfiles,
  getClient,
  getClientProfilesDetails,
  getPublicClient,
  getClientAllBoards
};

export default service;